import { render, staticRenderFns } from "./DQPRTable.vue?vue&type=template&id=5eb6f32d&scoped=true&"
import script from "./DQPRTable.vue?vue&type=script&lang=js&"
export * from "./DQPRTable.vue?vue&type=script&lang=js&"
import style0 from "./DQPRTable.vue?vue&type=style&index=0&id=5eb6f32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb6f32d",
  null
  
)

export default component.exports